(function () {
  'use strict';
  var dialog = document.getElementById('TextualSearchDialog');
  if (!dialog || !dialog.showModal) return;
  var input = dialog.querySelector('[name="q"]');
  var suggestions = dialog.querySelector('[data-search-suggestions]');
  var products = dialog.querySelector('[data-search-products]');
  var status = dialog.querySelector('[data-search-status]');
  var clear = dialog.querySelector('[data-search-clear]');
  var opener, restoring = false, timer, controller, version = 0, overflow;
  function el(tag, className, text) {
    var node = document.createElement(tag);
    node.className = 'tt-search__' + className;
    if (text) node.textContent = text;
    return node;
  }
  function words(value) { return value.replace(/["*\\]/g, '').trim().split(/\s+/).filter(Boolean); }
  function resultURL(value) {
    var url = new URL(input.form.action, location.origin);
    url.searchParams.set('q', words(value).map(function (word) { return '(title:"' + word + '" OR tag:"' + word + '")'; }).join(' AND '));
    url.searchParams.set('type', 'product'); url.searchParams.set('sort_by', 'relevance');
    return url.href;
  }
  function cancel() { clearTimeout(timer); if (controller) controller.abort(); version++; }
  function defaults() {
    suggestions.replaceChildren(document.getElementById('TextualSearchDefaultSuggestions').content.cloneNode(true));
    products.replaceChildren(document.getElementById('TextualSearchDefaultProducts').content.cloneNode(true));
    status.textContent = 'Explore new designs and best sellers.';
  }
  function open(target, value) {
    if (restoring || dialog.open) return;
    opener = target;
    input.value = value || '';
    overflow = [document.documentElement.style.overflow, document.body.style.overflow];
    document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden';
    dialog.showModal(); input.focus(); update();
  }
  function close() {
    cancel(); restoring = true;
    dialog.close();
    document.documentElement.style.overflow = overflow[0]; document.body.style.overflow = overflow[1];
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    setTimeout(function () { restoring = false; }, 0);
  }
  function allLink(value) {
    var link = el('a', 'view-all', 'See all results →'); link.href = resultURL(value); return link;
  }
  function productCard(product) {
    var link = el('a', 'product'); link.href = product.url;
    var frame = el('span', 'product-image');
    if (product.image) {
      var image = document.createElement('img');
      var src = new URL(product.image, location.origin); src.searchParams.set('width', '360');
      image.src = src.href; image.alt = ''; image.loading = 'lazy'; frame.append(image);
    }
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var price = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency }).format(Number(product.price));
    link.append(frame, el('span', 'product-title', product.title), el('span', 'product-price', price));
    if (product.available === false) link.append(el('span', 'sold-out', 'Sold out'));
    return link;
  }
  function render(data, value) {
    var results = data.resources.results;
    var terms = words(value.toLocaleLowerCase());
    var matches = (results.products || []).filter(function (product) {
      var text = [product.title, (product.tags || []).join(' ')].join(' ').toLocaleLowerCase();
      return terms.every(function (term) { return text.indexOf(term) !== -1; });
    }).slice(0, 16);
    suggestions.replaceChildren(el('h3', 'heading', 'Suggested searches'));
    var list = el('div', 'suggestion-list');
    var queries = (results.queries || []).map(function (query) { return query.text; });
    if (!queries.length) queries = matches.slice(0, 5).map(function (product) { return product.title; });
    if (!queries.length) queries = [value];
    queries.slice(0, 6).forEach(function (text) {
      var button = el('button', 'text-link', text); button.type = 'button'; button.dataset.searchTerm = text; list.append(button);
    });
    suggestions.append(list);
    if (results.collections && results.collections.length) {
      suggestions.append(el('h3', 'heading tt-search__heading--spaced', 'Collections'));
      var collections = el('div', 'suggestion-list');
      results.collections.slice(0, 4).forEach(function (collection) {
        var link = el('a', 'text-link', collection.title); link.href = collection.url; collections.append(link);
      });
      suggestions.append(collections);
    }
    var header = el('div', 'shelf-header');
    header.append(el('h3', 'heading', 'Recommended products'), allLink(value));
    products.replaceChildren(header);
    var collectionCards = (data.searchCards || []).concat(data.collectionCards || []);
    if (matches.length || collectionCards.length) {
      var grid = el('div', 'product-grid'); matches.forEach(function (product) { grid.append(productCard(product)); }); var seen = new Set(matches.map(function (product) { return new URL(product.url, location.origin).pathname; }));
      collectionCards.forEach(function (card) {
        var path = new URL(card.href, location.origin).pathname;
        if (!seen.has(path) && grid.children.length < 16) { grid.append(document.importNode(card, true)); seen.add(path); }
      });
      products.append(grid);
    } else products.append(el('p', 'note', 'No matching products found. Try a different design, theme or product.'));
    var footer = el('div', 'results-footer'); footer.append(allLink(value)); products.append(footer);
    status.textContent = products.querySelectorAll('.tt-search__product').length + ' product suggestions for ' + value + '.';
  }
  function update() {
    cancel(); var currentVersion = version, value = input.value.trim(); clear.hidden = !value;
    products.removeAttribute('aria-busy');
    if (value.length < 2 || !words(value).length) { defaults(); return; }
    suggestions.replaceChildren(el('h3', 'heading', 'Suggested searches'), el('p', 'note', 'Finding suggestions…'));
    products.replaceChildren(el('h3', 'heading', 'Recommended products'), el('p', 'note', 'Searching…'));
    products.setAttribute('aria-busy', 'true'); status.textContent = 'Searching for ' + value;
    timer = setTimeout(async function () {
      var request = new AbortController(); controller = request;
      var timeout = setTimeout(function () { request.abort(); }, 10000);
      var url = new URL(input.form.action.replace(/\/$/, '') + '/suggest.json', location.origin);
      url.searchParams.set('q', value); url.searchParams.set('resources[type]', 'product,query,collection');
      url.searchParams.set('resources[limit]', '10'); url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      function current() { return dialog.open && currentVersion === version && input.value.trim() === value; }
      try {
        var response = await fetch(url, { signal: request.signal });
        if (!response.ok) throw new Error('Search unavailable');
        var data = await response.json();
        var collectionMatches = data.resources.results.collections || [];
        if (current()) {
          async function previewCards(previewURL) {
            previewURL.searchParams.set('section_id', 'search-preview-products');
            var previewResponse = await fetch(previewURL, { signal: request.signal });
            if (!previewResponse.ok) throw new Error('Preview unavailable');
            var previewHTML = new DOMParser().parseFromString(await previewResponse.text(), 'text/html');
            return Array.from(previewHTML.querySelectorAll('.tt-search__product')).slice(0, 16);
          }
          var previews = [previewCards(new URL(resultURL(value)))];
          if (collectionMatches.length) {
            var collectionURL = new URL(collectionMatches[0].url, location.origin);
            collectionURL.search = ''; previews.push(previewCards(collectionURL));
          }
          var previewResults = await Promise.allSettled(previews);
          if (previewResults[0].status === 'fulfilled') data.searchCards = previewResults[0].value;
          if (previewResults[1] && previewResults[1].status === 'fulfilled') data.collectionCards = previewResults[1].value;
        }
        if (current()) render(data, value);
      } catch (error) {
        if (current()) {
          defaults(); products.prepend(el('p', 'note', 'Live suggestions are unavailable. You can still search the full store.'), allLink(value));
          status.textContent = 'Live suggestions unavailable. Use Search to see all results.';
        }
      } finally { clearTimeout(timeout); if (current()) products.removeAttribute('aria-busy'); }
    }, 200);
  }
  input.addEventListener('input', function (event) { if (!event.isComposing) update(); });
  input.addEventListener('compositionend', update);
  input.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowDown') { var first = suggestions.querySelector('button, a'); if (first) { event.preventDefault(); first.focus(); } }
  });
  dialog.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close(); }
  }, true);
  dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(); });
  dialog.querySelector('[data-search-close]').addEventListener('click', close);
  var startedOutside = false;
  function outside(event) {
    var bounds = dialog.getBoundingClientRect();
    return event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom);
  }
  dialog.addEventListener('pointerdown', function (event) { startedOutside = outside(event); });
  dialog.addEventListener('click', function (event) {
    if (startedOutside && outside(event)) close();
    startedOutside = false;
  });
  clear.addEventListener('click', function () { input.value = ''; update(); input.focus(); });
  suggestions.addEventListener('click', function (event) {
    var button = event.target.closest('[data-search-term]');
    if (button) { input.value = button.dataset.searchTerm; update(); input.focus(); }
  });
  input.form.addEventListener('submit', function (event) {
    event.preventDefault(); if (words(input.value).length) location.assign(resultURL(input.value)); else input.focus();
  });
  function trigger(event) {
    var target = event.target.closest('.js-search-bar-input, .js-search-bar-button');
    if (!target || dialog.contains(target) || restoring) return;
    event.preventDefault(); event.stopImmediatePropagation(); open(target, target.matches('input') ? target.value : '');
  }
  document.addEventListener('click', trigger, true);
  document.addEventListener('focusin', trigger, true);
  document.addEventListener('submit', function (event) {
    var field = event.target.querySelector('.js-search-bar-input');
    if (field) { event.preventDefault(); event.stopImmediatePropagation(); open(field, field.value); }
  }, true);
  window.textualSearch = function (field) { open(field, field.value); };
  document.documentElement.classList.add('tt-search-enhanced');
})();
